import { NgModule } from '@angular/core';
import { Autoresize } from './autoresize';

@NgModule({
    imports: [],
    declarations: [Autoresize],
    exports: [Autoresize]
})
export class PipesModule { }


// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts